(function () {
  class ScImageWithTextSlider {
    constructor(container) {
      this.container = container;
      this.slides = [...container.querySelectorAll(".sc-image-with-text__slide")];
      this.prevBtn = container.querySelector("[data-sc-image-with-text-prev]");
      this.nextBtn = container.querySelector("[data-sc-image-with-text-next]");
      this.current = 0;
      this.autoplayDelay = parseInt(container.dataset.autoplay, 10) || 0;
      this.timer = null;

      if (this.slides.length < 2) return;

      this.bindEvents();
      if (this.autoplayDelay > 0) this.startAutoplay();
    }

    bindEvents() {
      this.prevBtn?.addEventListener("click", () => this.goTo(this.current - 1));
      this.nextBtn?.addEventListener("click", () => this.goTo(this.current + 1));

      this.container.addEventListener("mouseenter", () => this.stopAutoplay());
      this.container.addEventListener("mouseleave", () => {
        if (this.autoplayDelay > 0) this.startAutoplay();
      });
    }

    goTo(index) {
      const total = this.slides.length;
      this.current = ((index % total) + total) % total;

      this.slides.forEach((slide, i) => {
        slide.classList.toggle("is-active", i === this.current);
      });
    }

    selectBlock(blockId) {
      const index = this.slides.findIndex(
        (slide) => slide.dataset.slide === blockId,
      );
      if (index >= 0) {
        this.goTo(index);
        this.stopAutoplay();
      }
    }

    startAutoplay() {
      this.stopAutoplay();
      this.timer = setInterval(
        () => this.goTo(this.current + 1),
        this.autoplayDelay,
      );
    }

    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    destroy() {
      this.stopAutoplay();
    }
  }

  const instances = new WeakMap();

  function initSliders(root = document) {
    root.querySelectorAll("[data-sc-image-with-text-slider]").forEach((el) => {
      if (instances.has(el)) return;
      instances.set(el, new ScImageWithTextSlider(el));
    });
  }

  function destroySliders(root = document) {
    root.querySelectorAll("[data-sc-image-with-text-slider]").forEach((el) => {
      instances.get(el)?.destroy();
      instances.delete(el);
    });
  }

  document.addEventListener("DOMContentLoaded", () => initSliders());

  document.addEventListener("shopify:section:load", (event) => {
    initSliders(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    destroySliders(event.target);
  });

  document.addEventListener("shopify:block:select", (event) => {
    const section = event.target.closest(".shopify-section--image-with-text");
    if (!section) return;

    const slider = section.querySelector("[data-sc-image-with-text-slider]");
    const instance = slider ? instances.get(slider) : null;
    instance?.selectBlock(event.detail.blockId);
  });

  document.addEventListener("shopify:block:deselect", (event) => {
    const section = event.target.closest(".shopify-section--image-with-text");
    if (!section) return;

    const slider = section.querySelector("[data-sc-image-with-text-slider]");
    const instance = slider ? instances.get(slider) : null;
    if (instance?.autoplayDelay > 0) instance.startAutoplay();
  });
})();
